import VueCookies from 'vue-cookies'
import Vue from 'vue'
import {
    getOrganization
} from "@/api/commonApi";

export default {
    state: {
        org_info: {
            logo: "",
            system_long_name: "",
            system_sort_name: "",
            org_code: "",
            page_title: "",
            favicon: ""
        }
    },

    getters: {
        getOrgLogo: state => {
            return state.org_info.logo
        },
        getOrgInfo: state => {
            return state.org_info
        },
        getOrgCode: state => {
            return state.org_info.org_code
        },
        getOrgSortName: state => {
            return state.org_info.system_sort_name
        }
    },
    mutations: {
        SET_ORG_INFO: (state, data) => {
            state.org_info = data;
        }
    },
    actions: {
        GET_ORGANIZATION({
            commit
        }) {
            return new Promise((resolve, reject) => {
                getOrganization()
                    .then(res => {
                        if (res.errCode == 0) {
                            localStorage.setItem("common_org_code", res.data.org_code);
                            localStorage.setItem("common_logo", res.data.logo);
                            localStorage.setItem("common_favicon", res.data.favicon);
                            localStorage.setItem("common_page_title", res.data.page_title);
                            localStorage.setItem(
                                "common_system_sort_name",
                                res.data.system_sort_name
                            );
                            localStorage.setItem("common_home_url", res.data.home_url);
                            // document.title =  Vue.prototype.judeIsElectron() ? '爱米云课件' : res.data.page_title;
                            document.title = res.data.page_title;
                            let link = document.getElementById("link-icon");
                            link.href = res.data.favicon;
                            localStorage.setItem("home_url", res.data.home_url);
                            this.show_project_status = true;
                            commit('SET_ORG_INFO', res.data);
                            resolve();
                        } else {
                            reject();
                        }
                    })
                    .catch(err => {
                        reject();
                        throw new Error(err);
                    });
            });
        }
    }
}
